import { Modal, ModalBody } from "reactstrap";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { titlevalidation } from "../../../../Common/commonvalidation";
import { addresstips } from "../../../../Common/Tooltips/tooltip";
import ChoosePostType from "../../../../Common/ChoosePostType";
import { Tooltip } from "react-tooltip";
import { useSelector } from "react-redux";

export default function AddAddressModel({ data, modal, setModal, AddAddressApihit }) {
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const validationSchema = Yup.object().shape({
    address: titlevalidation,
  });

  return (
    <Modal
      className="popupmodal"
      isOpen={modal}
      toggle={() => setModal(false)}
    >
      <button
        onClick={() => setModal(false)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>

      <ModalBody>
        {/* <img
          data-tooltip-id="my-tooltip-2"
          src={`${CloudStorage.cloudurl}/Assets/Images/common/info-circle.svg`}
          alt=""
        /> */}
        <h4>Add Address</h4>
        <p>Please enter the delivery address below.</p>

        <Formik
          initialValues={{ address: data?.address || profile?.address || "" }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            AddAddressApihit(values);
            setModal(false);
          }}
        >
          {() => (
            <Form>
              <div className="form-group mt-3">
                <label>Address</label>
                <Field
                  name="address"
                  className="form-control"
                  placeholder="Enter address"
                />
                <ErrorMessage
                  name="address"
                  component="div"
                  className="text-danger mt-1"
                />
              </div>

              <div className="modal-footer mt-4">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
        <Tooltip
          id="my-tooltip-2"
          place="bottom"
          content={addresstips}
        />
      </ModalBody>
    </Modal>
  );
}
